"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

var GridContext_1 = require("./GridContext");

var InnerGrid_1 = require("./InnerGrid");

function Grid(_a) {
  var itemHeight = _a.itemHeight,
      header = _a.header,
      contextValue = __rest(_a, ["itemHeight", "header"]);

  var ref = react_1.default.useRef(null);

  var _ref = (0, web_1.useResizeObserver)({
    ref: ref
  }),
      width = _ref.width;

  return react_1.default.createElement(GridContext_1.GridContext.Provider, {
    value: contextValue
  }, react_1.default.createElement("div", {
    ref: ref,
    style: {
      width: '100%'
    }
  }, width && width > 10 ? react_1.default.createElement(InnerGrid_1.InnerGrid, {
    width: width,
    itemHeight: itemHeight,
    header: header
  }) : null));
}

exports.Grid = Grid;